var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-modal",
    {
      staticClass: "modal-login",
      attrs: { shown: _vm.shown },
      on: { close: _vm.handleClose },
    },
    [
      _c("div", { staticClass: "center-content-position" }, [
        _vm.errorMessage
          ? _c("div", { staticClass: "alert alert-danger" }, [
              _vm._v(_vm._s(_vm.errorMessage) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.recoverMode
          ? _c("div", [
              _c("h1", [_vm._v("Login")]),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: { name: "form", role: "form" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleLogin.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "has-error": _vm.errors.has("username") },
                    },
                    [
                      _c("label", { attrs: { for: "username" } }, [
                        _vm._v("Email"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        key: "username-base",
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          name: "username",
                          id: "username",
                          required: "",
                        },
                        domProps: { value: _vm.username },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.username = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.has("username")
                        ? _c("span", { staticClass: "help-block" }, [
                            _vm._v("Email is required"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "has-error": _vm.errors.has("password") },
                    },
                    [
                      _c("label", { attrs: { for: "password" } }, [
                        _vm._v("Password"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        key: "password-base",
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          name: "password",
                          id: "password",
                          required: "",
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.password = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.has("password")
                        ? _c("span", { staticClass: "help-block" }, [
                            _vm._v("Password is required"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "cta-button",
                        attrs: {
                          type: "submit",
                          disabled: _vm.errors.any() || _vm.isLoading,
                        },
                      },
                      [_vm._v("Login")]
                    ),
                    _vm._v(" "),
                    _vm.isLoading
                      ? _c("img", {
                          attrs: {
                            src: "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-link",
                        on: { click: _vm.displayRegister },
                      },
                      [_vm._v("Create New Account")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-link",
                        on: {
                          click: function ($event) {
                            _vm.recoverMode = true
                          },
                        },
                      },
                      [_vm._v("Recover password")]
                    ),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.recoverMode
          ? _c("div", [
              _c("h1", [_vm._v("Recover Password — Step 1")]),
              _vm._v(" "),
              !_vm.isRecoveryStarted
                ? _c("div", [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "padding-bottom": "0",
                          color: "#B0B1BA",
                        },
                      },
                      [
                        _vm._v(
                          "Provide the email that you used to register account, and we will initiate a password reset."
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        attrs: { name: "formRecover", role: "form" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.recoverPassword.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: { "has-error": _vm.errors.has("email") },
                          },
                          [
                            _c("label", { attrs: { for: "email" } }, [
                              _vm._v("Email"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email",
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'",
                                },
                              ],
                              key: "username-recover",
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                name: "email",
                                id: "email",
                                required: "",
                              },
                              domProps: { value: _vm.email },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.email = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.errors.has("email")
                              ? _c("span", { staticClass: "help-block" }, [
                                  _vm._v("Email is required"),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "cta-button",
                              attrs: {
                                type: "submit",
                                disabled: _vm.errors.any() || _vm.isLoading,
                              },
                            },
                            [_vm._v("Recover Password")]
                          ),
                          _vm._v(" "),
                          _vm.isLoading
                            ? _c("img", {
                                attrs: {
                                  src: "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-link",
                              on: {
                                click: function ($event) {
                                  _vm.recoverMode = false
                                },
                              },
                            },
                            [_vm._v("Login now")]
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isRecoveryStarted
                ? _c("div", [
                    _c("p", { staticStyle: { color: "#666" } }, [
                      _vm._v(
                        "An email has been sent to " +
                          _vm._s(_vm.email) +
                          ", please follow instructions in that email."
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: { click: _vm.handleClose },
                      },
                      [_vm._v("OK")]
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }